import type { TableHeaderColumn } from '@/modules/drivers/types'

export type ImiDeclarationSortKey =
  | 'driver'
  | 'country'
  | 'start'
  | 'end'
  | 'status'

// Column config for the IMI declarations table. The leading checkbox column is
// rendered separately (see ImiDeclarationsTable) because its select-all needs a
// controlled `checked` + `indeterminate` + `disabled` that the context-driven
// TableCheckboxHeader inside <TableHeader> doesn't support — the same reason
// DriversContractTable passes `disabledCheckboxToggle`.
export const getImiDeclarationsColumns = (
  t: (key: string) => string,
): TableHeaderColumn[] => [
  { title: t('common.driver'), key: 'driver', type: 'string', sort: true },
  { title: t('common.country'), key: 'country', type: 'string', sort: true },
  { title: t('exportModule.start'), key: 'start', type: 'date', sort: true },
  { title: t('exportModule.end'), key: 'end', type: 'date', sort: true },
  { title: t('common.status'), key: 'status', type: 'string', sort: true },
  { title: t('common.actions'), key: null, type: 'string', sort: false },
]
